import './PlanBenefitTile.scss';

import { ProductOfferingOrderType } from '@travelwin/core';
import classNames from 'classnames';
import { ReactNode, SyntheticEvent, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  getPlanBenefitDetails,
  PlanBenefitTypesKeys,
} from './planBenefitTypes';

interface Props {
  type: PlanBenefitTypesKeys;
  value: number;
  onClick?: (e: SyntheticEvent<HTMLButtonElement>) => void;
  planType?: ProductOfferingOrderType;
  countryKeys?: string[];
}

const className = 'c-PlanBenefitTile';

const PlanBenefitTile = ({
  type,
  value,
  onClick,
  planType,
  countryKeys,
}: Props) => {
  const { t } = useTranslation();
  const benefitDetails = useMemo(
    () => getPlanBenefitDetails(t, value, countryKeys),
    [t, value, countryKeys],
  );

  if (value === 0) {
    return null;
  }

  return (
    <PlanBenefitTileWrapper planType={planType} onClick={onClick}>
      <div className={`${className}__icon`}>{benefitDetails[type].icon}</div>
      <div className={`${className}__text`}>
        {countryKeys?.length !== 2 && (
          <span>
            {value !== -1 ? value : t('landing.plan.unlimited', 'Unlimited')}{' '}
          </span>
        )}
        <span>{benefitDetails[type].label}</span>
      </div>
    </PlanBenefitTileWrapper>
  );
};

const PlanBenefitTileWrapper = ({
  onClick,
  planType,
  children,
}: {
  children: ReactNode;
  planType?: ProductOfferingOrderType;
  onClick?: (e: SyntheticEvent<HTMLButtonElement>) => void;
}) =>
  onClick ? (
    <button
      type="button"
      className={classNames(
        className,
        `${className}--clickable`,
        `${className}--clickable--${planType}`,
      )}
      onClick={onClick}
    >
      {children}
    </button>
  ) : (
    <div className={className}>{children}</div>
  );

export default PlanBenefitTile;
